<template>
  <div>
    <el-button
      :disabled="disabled"
      :loading="isLoading"
      @click="runAction"
    >
      <slot />
    </el-button>
  </div>
</template>

<script>
  export default {
    name: 'EmActionButton',
    props: {
      action: {
        type: Function,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    methods: {
      runAction () {
        this.isLoading = true
        this.action().then(res => {
          this.isLoading = false
          return res
        })
      }
    }
  }
</script>
